
import React, { Component } from 'react'
import { Button, Icon, Popup, Grid, Header, Segment, Divider, List, Image, Loader } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';
import { history } from '../../../../helpers';
import { toastr } from 'react-redux-toastr';
import designerImage from '../../../../images/svg/Export/playbook.svg';
import ClosedInitiativeModal from '../../../workspace/Initiatives/Drive/modals/CompleteInitiative'
import "./Toolbar.css";
import _ from 'lodash';
import CopyActivityModal from '../../../workspace/Initiatives/Drive/modals/CopyActivityModal';
import { isBlockedBySubscriptionLimit } from "../../../../helpers/subscriptionLimitCheck";


class ToolbarInitiative extends Component {

  constructor(props) {
    super(props);
    this.state = {
      setClosedModalStatus: false,
      ActivityNode: "",
      infoStatement1: "",
      infoStatement2: ""
    }

  }

  createInitiative = (e) => {
    const { history } = this.props;
    const { accountSubscriptionDetail } = this.props
    let defaults = accountSubscriptionDetail.consumptionDefaults || {};
    if (isBlockedBySubscriptionLimit({
      accountSubscriptionDetail,
      selectedAccount: this.props.selectedAccount,
      user: this.props.user,
      requiredCredits: defaults.initiativeCreated,
      entity: "Initiatives",
      entityType: "Initiatives",
    })) {
      // blocked, modal shown by helper
    } else {
      history.push('/app/' + this.props.selectedAccount._id + '/_ws/' + this.props.selectedOrganisation.id + '/_in/indesign/selectPlaybook');
      dispatch.app.setCollapsedResourcePaneIndexTemp(null)
      dispatch.initiatives.showResourecePane(null);
      dispatch.initiatives.initiativeAggangementPane(null);
      dispatch.initiatives.setSelectedInitiative({});
      dispatch.initiatives.setSelectedDataById({});
      dispatch.initiatives.setTabName(null);
    }
  }

  closedInitiativeClicked = (e, open, labelType) => {

    this.setState({ setClosedModalStatus: open, labelType: labelType })
  }

  iconClick = (props) => {
    if (this.props.enableDependencyIcon) {
      dispatch.lifeCycle.disableLinking();
      dispatch.lifeCycle.setDependencyIcon(false);
    }
    else {
      dispatch.lifeCycle.enableLinking();
      dispatch.lifeCycle.setDependencyIcon(true);
    }

  }
  copyIconClick = (props) => {
    dispatch.initiatives.copyActivityModalOpen(true);
    if(this.props.selectedActivityData.isLeafNode){
      let infoStatement1 = `Activity will be copied under stage ${this.props.selectedActivityData.parentActivity.name}`;
      let infoStatement2 = '';
      if(this.props.selectedActivityData && this.props.selectedActivityData.parentActivity && this.props.selectedActivityData.parentActivity.parentActivity){
        infoStatement2 = `The new activity created by copying will appear under below stage`;
      } else {
        infoStatement2 = `The new activity created by copying will appear under below phase`;
      }
      this.setState({ActivityNode: "Activity"})
      this.setState({infoStatement1: infoStatement1})
      this.setState({infoStatement2: infoStatement2})
    } else if(this.props.selectedActivityData.isParentNode && this.props.selectedActivityData.parentActivity){
      let noOfActivities = this.props.selectedActivityData.activities.length;
      let infoStatement1 = '';
      let infoStatement2 = `The new stage created by copying will appear under below phase`;
      if(noOfActivities > 1){
        infoStatement1 = `All ${noOfActivities} activities under this stage will be copied under phase ${this.props.selectedActivityData.parentActivity.name}`;
      } else {
        infoStatement1 = `Activity under this stage will be copied under phase ${this.props.selectedActivityData.parentActivity.name}`;
      }
      this.setState({ActivityNode: "Stage"})
      this.setState({infoStatement1: infoStatement1})
      this.setState({infoStatement2: infoStatement2})
    } else {
      let noOfStages = this.props.selectedActivityData.activities.length;
      let infoStatement1 = '';
      let infoStatement2 = `The new phase created by copying will appear below`;
      if(noOfStages > 1){
        infoStatement1 = `All ${noOfStages} stages and respective activities under this phase will be copied.`;
      } else {
        infoStatement1 = `Stage and respective activities under this phase will be copied.`;
      }
      this.setState({ActivityNode: "Phase"})
      this.setState({infoStatement1: infoStatement1})
      this.setState({infoStatement2: infoStatement2})
    }
  }
  disableLinking = () => {
    dispatch.lifeCycle.disableLinking();
    dispatch.lifeCycle.setDependencyIcon(false);
  }


  deleteInitiative = () => {
    let payload = Object.assign({}, this.props.selectedDataById);
    payload.initId = payload._id;
    let message = <div className="confirmMessage">
      <h3>Delete Initiative</h3>
      <label>{this.props.selectedDataById.name}</label>
      <p>Are you sure that you wish to do this?</p>
      <span >This action is not reversible</span>
    </div>
    toastr.confirm(message, {
      onOk: () => {
        dispatch.app.setCollapsedResourcePaneIndexTemp(null)
        dispatch.initiatives.showResourecePane(null);
        dispatch.initiatives.removeInitiative(payload);
      }
    });
  }
  editInitiative = () => {
    let payload = Object.assign({}, this.props.selectedDataById);
    let message = <div className="confirmMessage">
      <h3>Edit Initiative</h3>
      <label>{this.props.selectedDataById.name}</label>
      <p>Are you sure that you want to edit this initiative?</p>
      <span >This Initiative and related activities will be inaccessible to other participants while editing</span>
    </div>
    toastr.confirm(message, {
      onOk: () => {
        dispatch.app.setCollapsedResourcePaneIndexTemp(null)
        dispatch.initiatives.showResourecePane(null);
        dispatch.initiatives.setSelectedActivityData({});
        const { accountId, organizationId } = payload;
        dispatch.initiatives.editInitiative({ initiativeId: payload._id, organizationId, accountId });
      }
    });
  }

  startInitiative = () => {
    let initObj = {}
    initObj.status = 1;
    initObj.id = this.props.selectedDataById._id;

    dispatch.initiatives.updateInitiative(initObj);
    toastr.success('Message', `${this.props.selectedDataById.name} Initiative started successfully.`);
    this.setState({ open: true })
  }
  exportInitiative = () => {
    let message = <div className="confirmMessage">
      <h3>Export to Playbook</h3>
      <label>{this.props.selectedDataById && this.props.selectedDataById.name ? this.props.selectedDataById.name : ""}</label>
      <p>Are you sure you want to export this initiative as playbook?</p>
      <span style={{ color: "#a9a9a9" }}>This action will not export comments and attachments added at playbook/activity level.</span>
    </div>
    toastr.confirm(message, {
      okText: 'Export ',
      onOk: async () => {
        dispatch.initiatives.exportInitiative(this.props.selectedDataById);
      }
    });
  }



  filterData = (data) => {

  }

  render() {
    let objValidation = this.props.selectedDataById ? Object.entries(this.props.selectedDataById).length === 0 && this.props.selectedDataById.constructor === Object : {}
    let roleValidation = (this.props.selectedOrganisation.role !== 'workspaceOwner' && this.props.user._id.toString() !== this.props.selectedDataById.createdBy)
    let selectedActivity = (this.props.selectedActivityData && Object.entries(this.props.selectedActivityData).length > 0) ? true : false;
    return (
      <div className="toolBar header_buttons">
        <Button.Group size='mini' className="mar_Right_5">
          <Popup className="popupStyled" inverted trigger={<span onMouseEnter={() => dispatch.app.setHelpContext("Create Initiative")}><Button icon='plus' className="clr-blue" disabled={this.props.intitiativeCountData.publishedPlaybookCount === 0 || this.props.selectedDataById.status === 0} onClick={this.createInitiative} /></span>}
            content='Create Initiative'
          />
        </Button.Group>
        {this.props.activeTab === "configureActivity" ?
          <Button.Group size='mini' className="mar_Right_5">
            <Popup className="popupStyled" inverted trigger={<span onMouseEnter={() => dispatch.app.setHelpContext("Update Dependencies")}>
              {/* {this.props.enableDependencyIcon ? */}
              <Button
                icon='linkify'
                className={`clr-green ${this.props.enableDependencyIcon ? "toggleOn" : ""}`}
                onClick={this.iconClick}
                disabled={this.props.selectedActivityData && (!this.props.selectedActivityData.isLeafNode || this.props.selectedActivityData.runStatus === 1 || this.props.selectedActivityData.runStatus === 2)} />
              {/* :
                 <Button
                   icon='linkify'
                   className="clr-green"
                   onClick={this.iconClick}
                   disabled={this.props.selectedActivityData && !this.props.selectedActivityData.isLeafNode && this.props.selectedActivityData.runStatus === 0} />
              } */}
            </span>}
              content='Add Dependency'
            />
          </Button.Group> : ''}
          {this.props.activeTab === "configureActivity" ?
          <Button.Group size='mini' className="mar_Right_5">
            <Popup className="popupStyled" inverted trigger={<span onMouseEnter={() => dispatch.app.setHelpContext("Copy Activity")}>
              <Button
                icon='copy'
                className="clr-green"
                onClick={this.copyIconClick}
                disabled = {!selectedActivity}
              />
            </span>}
              content='Duplicate'
            />
          </Button.Group> : ''}
        {/* {this.props.selectedDataById && (this.props.selectedDataById.status === 1 || this.props.selectedDataById.status === 2) && */}
        <Button.Group size='mini' className="mar_Right_5">
          <Popup className="popupStyled" inverted trigger={<span onMouseEnter={() => dispatch.app.setHelpContext("Edit Initative")}><Button icon='pencil' className="clr-orange" onClick={this.editInitiative} disabled={objValidation || roleValidation || (this.props.selectedDataById && this.props.selectedDataById.version) || (this.props.selectedDataById.status === 0 || this.props.selectedDataById.status === 2 || this.props.selectedDataById.status === 3 || this.props.selectedDataById.status === 4 || this.props.selectedDataById.status === 5 || this.props.selectedDataById.status === -1)} /></span>}
            content='Edit Initiative'
          />
          {/* } */}
          {!(objValidation || roleValidation || (this.props.selectedDataById && this.props.selectedDataById.version) || this.props.selectedDataById.status === 4) ?
            <Popup
              trigger={<span onMouseEnter={() => dispatch.app.setHelpContext("Export Initiative")}>
                <Button
                  icon={<Icon name='cloud download' className="f_16" />}
                  className="clr-green "
                  disabled={objValidation || roleValidation || (this.props.selectedDataById && this.props.selectedDataById.version) || this.props.selectedDataById.status === 4} /></span>
              }
              flowing
              hoverable
              on="hover"

            >
              <Header className="f_14 mar_0">
              Export as 
              </Header>
              <Divider style={{ margin: "5px 0" }} />
              <List selection verticalAlign='middle'>
                <List.Item onClick={this.exportInitiative}>
                  <Image style={{ height: "16px" }} src={designerImage} />
                  <List.Content>
                    Playbook
                  </List.Content>
                </List.Item>
              </List>
            </Popup> :
            <span onMouseEnter={() => dispatch.app.setHelpContext("Export Initiative")}><Button icon={<Icon name="cloud download" className="f_16" />} className="clr-green" disabled={objValidation || roleValidation || (this.props.selectedDataById && this.props.selectedDataById.version) || this.props.selectedDataById.status === 4} /></span>
          }
        </Button.Group>
        <Button.Group
          size='mini'
          className="mar_Right_5">
          <Popup
            className="popupStyled"
            inverted trigger={
              <span
                onMouseEnter={() => dispatch.app.setHelpContext("Cancel Initative")}>
                <Button
                  icon='window close'
                  className="clr-dark-gray"
                  onClick={(e) => this.closedInitiativeClicked(e, true, "cancel")}
                  disabled={objValidation || roleValidation || (this.props.selectedDataById && this.props.selectedDataById.version) || this.props.selectedDataById.status === 3 || this.props.selectedDataById.status === 4 || this.props.selectedDataById.status === 5} />
              </span>
            }
            content="Cancel Initiative"
          />
          <Popup
            className="popupStyled"
            inverted trigger={
              <span
                onMouseEnter={() => dispatch.app.setHelpContext("Closed Initative")}>
                <Button
                  icon='check square '
                  className="clr-green"
                  onClick={(e) => this.closedInitiativeClicked(e, true, "close")}
                  disabled={_.isEmpty(this.props.selectedDataById) || (this.props.selectedDataById.status === 0 || this.props.selectedDataById.status === 1 || this.props.selectedDataById.status === 3 || this.props.selectedDataById.status === 4 || this.props.selectedDataById.status === 5 || this.props.selectedDataById.status === -1)} />
              </span>
            }
            content="Closed Initiative"
          />
          <Popup
            className="popupStyled"
            inverted trigger={
              <span
                onMouseEnter={() => dispatch.app.setHelpContext("Delete Initative")}>
                <Button
                  icon='trash'
                  className="clr-orange"
                  onClick={this.deleteInitiative}
                  disabled={objValidation || roleValidation || (this.props.selectedDataById && this.props.selectedDataById.version)} />
              </span>
            }
            content='Delete Initative'
          />
        </Button.Group>

        <ClosedInitiativeModal
          open={this.state.setClosedModalStatus}
          labelType={this.state.labelType}
          closedInitiativeClicked={this.closedInitiativeClicked}
          selectedDataById={this.props.selectedDataById}
          user={this.props.user}
          selectedOrganisation={this.props.selectedOrganisation}
          selectedAccount={this.props.selectedAccount}
          history={history}
        />
        <CopyActivityModal
        isCopyActivityModalOpen={this.props.isCopyActivityModalOpen}
        selectedActivityData = {this.props.selectedActivityData}
        ActivityNode = {this.state.ActivityNode}
        infoStatement1 = {this.state.infoStatement1}
        infoStatement2 = {this.state.infoStatement2}
        />

      </div>
    )
  }
}


export default ToolbarInitiative


